import { render, staticRenderFns } from "./AffiliateAdvertisement.vue?vue&type=template&id=40504504&scoped=true"
import script from "./AffiliateAdvertisement.vue?vue&type=script&lang=js"
export * from "./AffiliateAdvertisement.vue?vue&type=script&lang=js"
import style0 from "./AffiliateAdvertisement.vue?vue&type=style&index=0&id=40504504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40504504",
  null
  
)

export default component.exports